import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';

export const CtaBand = ({ onBook }) => {
  return (
    <section
      className="relative bg-gradient-to-br from-[#C9A84C] via-[#C9A435] to-[#A88826] text-[#0D1B2A] py-16 md:py-24 overflow-hidden"
      data-testid="cta-band"
    >
      {/* Subtle pattern texture */}
      <div className="absolute inset-0 opacity-[0.08] mix-blend-overlay grain-texture pointer-events-none" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-white/20 blur-[150px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="md:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex items-center gap-3 mb-5"
            >
              <div className="h-px w-12 bg-[#0D1B2A]" />
              <span className="text-[#0D1B2A] text-xs tracking-[0.4em] uppercase font-semibold">
                Free quote in 2 hours
              </span>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="font-serif leading-[0.95] tracking-tight text-[#0D1B2A]"
              style={{ fontSize: 'clamp(2.25rem, 6vw, 4.5rem)' }}
            >
              Ready when you are.
              <br />
              <span className="font-light italic">Let's clean.</span>
            </motion.h2>
          </div>

          <div className="md:col-span-5 flex flex-col sm:flex-row md:flex-col gap-3 md:gap-4">
            <button
              onClick={onBook}
              className="group w-full bg-[#0D1B2A] text-white hover:bg-[#0A0E1A] px-8 py-5 text-xs tracking-[0.3em] uppercase font-semibold flex items-center justify-center gap-3 transition-all"
              data-testid="cta-band-book-btn"
            >
              Request Free Quote
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="tel:5712656239"
              className="group w-full border-2 border-[#0D1B2A] text-[#0D1B2A] hover:bg-[#0D1B2A] hover:text-white px-8 py-5 text-xs tracking-[0.3em] uppercase font-semibold flex items-center justify-center gap-3 transition-colors"
              data-testid="cta-band-call-btn"
            >
              <Phone className="w-4 h-4" />
              (571) 265-6239
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
